import React, { FC } from 'react'
import { handleScrollToTop } from 'components/SA/Facets/helpers'
import { updateBrowseUrl } from '../helpers/url'
import URLConnector, { ConnectorProps as URLProps } from '../connectors/Url'
import SelectHitsPerPage from 'components/SA/Pagination/SelectHitsPerPage'

const DEFAULT_HITS_PER_PAGE = 50

const BrowseHitsPerPage: FC<URLProps> = (props) => {
  const { hitsPerPage, getHref } = props

  const handleChangeHitsPerPage = ({ value }) => {
    handleScrollToTop(() => {
      const href = getHref({
        hitsPerPage: value,
        page: '', // Reset Page
      })
      updateBrowseUrl(href)
    })
  }

  return (
    <SelectHitsPerPage
      hitsPerPage={hitsPerPage || DEFAULT_HITS_PER_PAGE}
      handleChangeHitsPerPage={handleChangeHitsPerPage}
    />
  )
}

export default URLConnector(BrowseHitsPerPage)
